<div class="container" id="container">
  <div class="logo">
    <img [src]="comdicaLogo" alt="Conselho Municipal dos Direitos da Criança e do adolescente">
  </div>

  <div class="svg_container">
  </div>

  <div class="sections" [class.mobile]="isMobileView">
    <ng-container *ngIf="!isMobileView; else mobileSections">
      <ng-container *ngTemplateOutlet="aboutSection"></ng-container>
      <ng-container *ngTemplateOutlet="legislationSection"></ng-container>
      <ng-container *ngTemplateOutlet="meetingSection"></ng-container>
      <ng-container *ngTemplateOutlet="accountabilitySection"></ng-container>
      <ng-container *ngTemplateOutlet="contactSection"></ng-container>
    </ng-container>

    <ng-template #mobileSections>
      <ng-container [ngSwitch]="navigation">
        <ng-container *ngSwitchCase="0">
          <ng-container *ngTemplateOutlet="aboutSection"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="1">
          <ng-container *ngTemplateOutlet="legislationSection"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="2">
          <ng-container *ngTemplateOutlet="accountabilitySection"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="3">
          <ng-container *ngTemplateOutlet="meetingSection"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="4">
          <ng-container *ngTemplateOutlet="contactSection"></ng-container>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <ng-container *ngTemplateOutlet="aboutSection"></ng-container>
        </ng-container>
      </ng-container>
    </ng-template>
  </div>
</div>

<ng-template #aboutSection>
  <section class="section-block comdica-section">
    <span id="comdica"></span>
    <app-about-comdica></app-about-comdica>
  </section>
</ng-template>

<ng-template #legislationSection>
  <section class="section-block">
    <app-legislation></app-legislation>
  </section>
</ng-template>

<ng-template #meetingSection>
  <section class="section-block">
    <app-meeting-schedule></app-meeting-schedule>
  </section>
</ng-template>

<ng-template #accountabilitySection>
  <section class="section-block">
    <app-accountability></app-accountability>
  </section>
</ng-template>

<ng-template #contactSection>
  <section class="section-block">
    <app-contact></app-contact>
  </section>
</ng-template>
